import { Component, input, output } from '@angular/core';
import { MatListOption, MatSelectionList } from '@angular/material/list';
import { OrderData } from '@lfw/roesberg.liveforms.core';
import { TranslatePipe } from '@ngx-translate/core';
import { SelectionArguments } from '../../../shared/models/selection-arguments';
import { OnlineOrderListItemComponent } from '../online-order-list-item/online-order-list-item.component';

@Component({
  selector: 'lfw-online-order-list',
  templateUrl: './online-order-list.component.html',
  styleUrls: ['./online-order-list.component.scss'],
  imports: [MatSelectionList, MatListOption, OnlineOrderListItemComponent, TranslatePipe]
})
export class OnlineOrderListComponent {
  readonly data = input<OrderData[]>();
  readonly itemSelected = output<SelectionArguments>();
  readonly refreshOrders = output<void>();

  isLoading(): boolean {
    return !this.data();
  }

  hasNoData(): boolean {
    const data = this.data();
    return data?.length === 0;
  }

  onRefreshOrders(): void {
    this.refreshOrders.emit();
  }
}
